export { default } from './mergeBreakpoints'
export * from './mergeBreakpoints'
